import { useMemo } from "react";

export interface EnvironmentConfig {
  isDevelopment: boolean;
  isProduction: boolean;
  showProfileSelector: boolean;
  allowProfileSwitching: boolean;
}

export const useEnvironment = (): EnvironmentConfig => {
  return useMemo(() => {
    const isDevelopment = import.meta.env.DEV;
    const isProduction = import.meta.env.PROD;

    // Em produção, nunca permitir seletor de perfis
    const showProfileSelector =
      isDevelopment && import.meta.env.VITE_ENABLE_PROFILE_SELECTOR !== "false";
    const allowProfileSwitching =
      isDevelopment && import.meta.env.VITE_ENABLE_PROFILE_SELECTOR !== "false";

    return {
      isDevelopment,
      isProduction,
      showProfileSelector,
      allowProfileSwitching,
    };
  }, []);
};
